import getLocalString from "constants/Localization";
import { useCustomSendProposalPackageMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useSendProposalPackage() {
  const [mutation, { loading, error, data }] = useCustomSendProposalPackageMutation({
    refetchQueries: ["customGetProposal", "getProposal", "customGetProposals"],
  });

  const [sendProposalPackage, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "sendProposalPackage",
    },
    {
      successMessage: getLocalString("proposals.package-send-queued"),
      failureMessage: getLocalString("proposals.send-failure"),
      showValidationErrors: true,
      hideSpecificError: "Please input a job size.",
    }
  );

  return [sendProposalPackage, context] as const;
}
